export default function parseURLSearch(): { [key: string]: string } {
  if (!window.location.search || window.location.search === '?') {
    return {}
  }

  return window.location.search.substr(1).split('&').reduce((accumulator, part) => {
    const [key, value] = part.split('=')
    Object.assign(accumulator, { [key]: value })
    return accumulator
  }, {})
}
